import '@/shared/features/quiz-folder/consts/events.quiz-folder';
import { trackEvent } from '@zep/logger/tracking';
import type { FolderCreatePlace } from '@/shared/features/quiz-folder/consts/events.quiz-folder';
import { openOverlayOnce, prepareOverlayOnce } from '@/shared/utils/openOverlayOnce';
import type { Folder } from './types/folder.types';
const OVERLAY_ID = 'create-folder-modal';

/**
 * 폴더 만들기 모달을 연다.
 *
 * `onCreated` 를 주면 만든 폴더를 그쪽으로 넘기고 이동하지 않는다.
 */
export async function showCreateFolderModal({
  place,
  onCreated
}: {
  /** 만들기를 시작한 자리. */
  place: FolderCreatePlace;
  onCreated?: (folder: Folder) => void;
}) {
  const loaded = await prepareOverlayOnce(OVERLAY_ID, () => import('./components/CreateFolderModal'));
  if (!loaded) return;
  const {
    CreateFolderModal
  } = loaded;
  trackEvent('quiz_folder_create_modal_open', {
    place
  });
  openOverlayOnce(OVERLAY_ID, ({
    unmount
  }) => <CreateFolderModal place={place} onClose={unmount} onCreated={onCreated} />);
}